import { IFlatComboProduct } from '@/store/ducks/combos/types';

export interface ComboProductDimensions {
  width: string;
  height: string;
}

export interface ComboProductInfo {
  title: string;
  min_quantity?: number;
  variations_count: number;
  discountPrice: number;
  link: string;
}

export interface BaseComboProductProps {
  product: IFlatComboProduct;
  className?: string;
}

export interface ComboProductProps extends BaseComboProductProps {
  min_quantity?: number;
  discount_percentage: number;
  variations_count: number;
}

export interface DesktopComboProductProps extends BaseComboProductProps {
  info: ComboProductInfo;
  dimensions: ComboProductDimensions;
}

export type DeviceType = 'mobile' | 'desktop';

export const COMBO_STYLES = {
  DESKTOP: {
    containerHeight: '5.25rem',
    discountPosition: { right: '-16px', top: '-15px' },
    quantityPosition: {
      position: 'absolute' as const,
      bottom: '15px',
      left: '10px',
      color: '#868686',
    },
    pricePosition: {
      position: 'absolute' as const,
      right: '10px',
      bottom: '20px',
    },
  },
  MOBILE: {
    containerHeight: '5.25rem',
    discountPosition: { right: '-15px', top: '-10px', left: '' },
    quantityPosition: {
      position: 'absolute' as const,
      bottom: '7px',
      left: '90px',
      color: '#868686',
      fontSize: '0.831rem',
    },
    pricePosition: {
      position: 'absolute' as const,
      right: '10px',
    },
  },
} as const;
